module Client.LocationInvoices


open Client
open Client.Services
open Shared
open global.Elmish
open System
open Thoth.Fetch
open Thoth.Json
open Fetch.Types
open Feliz
open Feliz.MaterialUI
open Fable.MaterialUI.Icons
open Fable.MaterialUI.MaterialDesignIcons
open Feliz.UseElmish
open Fable.Core.Experimental
open System.Text.RegularExpressions
// open Fable.Core.JS

let renderBreadcrumbs customerId =
  Mui.breadcrumbs [
    breadcrumbs.children [
      Mui.link [
        prop.href (Client.Pages.toHash Pages.Page.Home)
        link.children "Home"
      ]
      Mui.link [
        prop.href (Client.Pages.toHash Pages.Page.Locations)
        link.children "Locations"
      ]
      Mui.link [
        prop.href (Client.Pages.toHash (Pages.Page.Location customerId))
        link.children "Location"
      ]
      Mui.typography [
        typography.color.textPrimary
        typography.children "Invoices"
      ]
    ]
  ]

let view = React.functionComponent (fun (inputProps: {| customerId : int; model : LoggedInModel; |}) ->
  let classes = Styles.useStyles ()
  let (invoices, setInvoices) = React.useState(Array.empty<Shared.AccountsReceivableInvoiceHeader>)
  let (error, setError) = React.useState<string option>(None)
  let (isLoading, setIsLoading) = React.useState(true)

  React.useEffectOnce(fun () ->
    promise {
      let! authHeader = Services.getAuthHeader()
      try
        let decoder = Services.decoder<Shared.AccountsReceivableInvoiceHeader []>
        let! response = Fetch.tryGet($"/api/Location/%i{inputProps.customerId}/Invoices", headers = [ authHeader ], decoder = decoder)
        match response with
        | Ok v ->
          setInvoices v
        | Result.Error fetchError ->
          match fetchError with
          | FetchError.DecodingFailed _ -> setError (Some "Problem parsing response")
          | FetchError.FetchFailed msg -> setError (Some "Problem fetching invoices")
          | FetchError.NetworkError msg -> setError (Some $"Network problem fetching invoices {msg}")
          | FetchError.PreparingRequestFailed _ -> setError (Some "Problem preparing request to fetch invoices")
      with e ->
        setError (Some e.Message)
      setIsLoading false
    } |> ignore
  )

  Html.div [
    renderBreadcrumbs inputProps.customerId
    Html.h2 "Invoices"
    if isLoading then
      Mui.circularProgress []
    else
      match error with
      | Some msg -> Html.p [ prop.style [ style.color.red ]; prop.text msg ]
      | None ->
        if Array.isEmpty invoices then
          Html.p "No invoices found"
        else
          Mui.list [
            prop.width 100
            list.children [
              for x in invoices do
                Mui.listItem [
                  listItem.alignItems.flexStart
                  listItem.button true
                  listItem.component' "a"
                  prop.href (Client.Pages.toHash (Pages.Page.LocationInvoice (inputProps.customerId,x.Id)))
                  listItem.children [
                    Mui.listItemText [
                      listItemText.primary x.InvoiceNumber
                      listItemText.secondary (sprintf "Due: %s" (x.DueDate.ToString("d")))
                    ]
                  ]
                ]
            ]
          ]
  ]
)
